import { DATE_SHORT_FORMAT } from '../../../../constants/date'
import {
  useContentOverflow,
  useDateLocale,
  useTimeZone,
} from '../../../../hooks'
import { FloatingTooltip } from '../../../Floating'
import { formatDate, getTooltip } from '../../../Table'

import * as styles from './EmailAttachedTagDate.module.css'

function EmailAttachedTagDate({ date }) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  const formattedDate = formatDate({
    date,
    dateFormat: DATE_SHORT_FORMAT,
    locale,
    timezone,
  })
  const dateTooltip = date ? getTooltip(date, locale, timezone) : null

  const { overflow, setContentOverflowRef } = useContentOverflow()

  const tooltipContent = dateTooltip || formattedDate

  return (
    <FloatingTooltip
      content={tooltipContent}
      disabled={!dateTooltip && !overflow}
    >
      <span className={styles.date} ref={setContentOverflowRef}>
        {formattedDate}
      </span>
    </FloatingTooltip>
  )
}

export default EmailAttachedTagDate
